<template>
  <div v-if="dataFinishedLoading" class="roles">
    <div>
      <h1 id="title">{{ $t(localeConsts.rolesTitle) }}</h1>
    </div>
    <div id="title">
      <h5>{{ $t(localeConsts.setRolesCurrentSprint) }}:</h5>
    </div>

    <div v-for="input in inputs" :key="input.name">
      <SearchSelect
        :name="$t(input.title)"
        :options="input.options"
        :selected-option="input.selectedOption"
        @handleChange="input.selectedOption = $event"
      ></SearchSelect>
    </div>

    <div class="datePicker">
      <b-form-datepicker v-model="selectedDate" :max="maxDate" :min="minDate" size="sm" class="calendar"></b-form-datepicker>
    </div>

    <div class="formButtons">
      <SubmitButton :disabled="SelectedSameOption(inputs)" @clickEvent="editAllUserRoles()"></SubmitButton>
    </div>

    <b-alert id="successMessage" :show="dismissCountDown" fade variant="success" @dismiss-count-down="countDownChanged">
      {{ $t(localeConsts.successMessage) }}
    </b-alert>
  </div>
</template>

<script>
import SearchSelect from '@/components/util/Inputs/SearchSelect'

import SubmitButton from '@/components/util/Buttons/FormButtons/SubmitButton'

import { generalHelperMethodsMixin } from '../../../mixins/generalHelperMethodsMixin'
import { manualValidationMixin } from '../../../mixins/manualValidationMixin'
import { filtersMixin } from '../../../mixins/filtersMixin'
import { settersMixin } from '../../../mixins/settersMixin'
import { alertMessagesMixin } from '../../../mixins/alertMessagesMixin'

import mapGettersMixin from '../../../mixins/mapGettersMixin'
import { apiFetchMethodsMixin } from '../../../mixins/apiFetchMethodsMixin'

import axios from '../../../../axios'
import moment from 'moment/moment'

export default {
  name: 'RolesComponent',
  components: { SearchSelect, SubmitButton },
  mixins: [
    generalHelperMethodsMixin,
    manualValidationMixin,
    mapGettersMixin,
    filtersMixin,
    settersMixin,
    alertMessagesMixin,
    apiFetchMethodsMixin
  ],

  data() {
    return {
      localeConsts: {
        rolesTitle: 'ROLES.TITLE',
        setRolesCurrentSprint: 'ROLES.SET_ROLES_CURRENT_SPRINT',
        successMessage: 'ALERT.ROLES_SUCCESSFULLY_CHANGED'
      },

      inputs: [
        {
          name: 'productOwner',
          title: 'GENERAl.PRODUCT_OWNER',
          options: [],
          selectedOption: null
        },

        {
          name: 'scrumMaster',
          title: 'GENERAl.SCRUM_MASTER',
          options: [],
          selectedOption: null
        }
      ],
      students: [],
      maxDate: moment().endOf().format('YYYY-MM-DD hh:mm'),
      minDate: moment().subtract(14, 'days').startOf().format('YYYY-MM-DD hh:mm'),
      selectedDate: new Date(),

      dataFinishedLoading: false
    }
  },

  async created() {
    this.dataFinishedLoading = await this.loadData()
  },

  methods: {
    async loadData() {
      await this.fetchGroupMembers()

      //filter out non student group members
      this.filterUserRoleAttributionsByStudents(this.fetchedGroupMembers)

      this.setStudentsOptions(this.students)

      //set the two select menus with the filtered student options
      this.inputs[0].options = this.students
      this.inputs[1].options = this.students

      return true
    },

    /*api write/edit methods*/

    async editAllUserRoles() {
      await this.editUserRole(this.inputs[0].selectedOption.value, 1, this.selectedDate)
      await this.editUserRole(this.inputs[1].selectedOption.value, 2, this.selectedDate)

      //show success message after successfully editing all user roles
      this.showAlert()
    },

    async editUserRole(userId, roleId, attributionDate) {
      const responseProjectId = await this.getProjectId
      const postUserRole = {
        user: userId,
        user_role: roleId,
        attribution_date: attributionDate,
        project: responseProjectId
      }

      await axios.post(`user-role-attributions/`, postUserRole)
    }
  }
}
</script>

<style lang="scss" scoped>
$text-color: #8b69a9;

.roles {
  width: 100%;
  color: $text-color;
}

#title {
  color: $text-color;
}

.h5 {
  display: flex;
  margin-top: 15px;
  margin-bottom: 20px;
}

.formButtons {
  display: flex;
  justify-content: center;
  margin-left: 13%;
  margin-top: 30px;
}

.datePicker {
  margin-left: 4.5%;
  margin-right: 38%;
}

#successMessage {
  margin-top: 15px;
  width: 62%;
}
</style>
